export default __webpack_public_path__ + "static/media/1.9f0bf7f2.png";